<template>
  <div class="wrapper">
    <div class="express" v-if="data.express_id&&!loading">
      <div class="top">
        <div class="left">
          <img
            :src="data.commodity_logo"
            alt
          />
        </div>
        <div class="right">
          <span>
            <span>物流状态：</span>
            <span v-if="status==1">已揽件</span>
            <span v-else-if="status==2&&statusEx==202">派件中</span>
            <span v-else-if="status==2">在途中</span>
            <span v-else-if="status==3">已签收</span>
            <span v-else-if="status==4">问题件</span>
          </span>
          <span>
            <span>物流公司：</span>
            <span>{{data.express_name||'暂无'}}</span>
          </span>
          <span>
            <span>物流单号：</span>
            <span>{{data.express_id||'暂无'}}<span v-if="data.express_id" class="expressCopy cbtn1" data-clipboard-action="copy" :data-clipboard-text="data.express_id" @click="copy">复制</span></span>
          </span>
        </div>
      </div>
      <div class="bottom">
        <div class="tite">
          <span>订单跟踪</span>
        </div>
        <div class="content">
          <van-steps direction="vertical" active-color="#333333">
            <van-step v-for="(item,index) in expressList" :key="index">
              <p :class="index==0?'title':'titleno'" v-html="item.AcceptStation"></p>
              <!-- <p :class="index==0?'text':'textno'">{{item.context}}</p> -->
              <p class="time">{{item.AcceptTime}}</p>
            </van-step>
          </van-steps>
          
        </div>
      </div>
    </div>
    <div class="no" v-else-if="!loading">
      <img src="../../assets/images/noExpress.png" alt="">
      <span>暂无物流信息</span>
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      data: {},
      status: "1",
      expressList:[],
      loading:true,
      active: 0,
      pageType: this.$route.query.pageType||'1',
      finalPhone: this.$route.query.final_phone||'',
    };
  },
  watch: {},
  methods: {
    copy() {
      let cbtn1 = new this.$clipboard(".cbtn1");
      cbtn1.on("success", e => {
        this.$toast({
          message: "复制成功",
          duration: 2000
        });
      });
      cbtn1.on("error", e => {
        this.$toast({
          message: "复制失败",
          duration: 2000
        });
      });
    },
    getData() {
      let that = this;
      let toast = this.$toast({
        mask: false,
        duration: 0,
        type: "loading"
      });
      that.$commonPost({
        jydm: "flow_30042",
        flow_30042: {
          record_nbr: that.$route.query.nbr
        }
      })
        .then(response => {
          if(response.express_id){
            if(this.pageType=='2'){
              response.express_id = this.$route.query.express_id
              response.express_name = this.$route.query.express_name
              response.express_note = ''
              that.getExpressKDN(response,toast)
            }else{
              that.getExpressKDN(response,toast)
            }
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getExpressKDN(response, toast){
      let that = this;
      that.$post("/api/customer/expressKDN", {
        userNbr: that.userInfo.nbr,
        expressId: response.express_id,
        customerName:response.express_name=='京东快递'?response.express_note?response.express_note:that.finalPhone:that.finalPhone,
        expressName:response.express_name,
      }).then(res => {
        let resp = res.object.resp;
        if (res.code == "200") {
          if (resp.resp_code == "0" && resp.resp_result == "0"){
            if(resp.express&&resp.express.State>0){
              that.data = response;
              that.status = resp.express.State;
              that.statusEx = resp.express.StateEx;
              that.expressList = resp.express.Traces.reverse();
            }
          }
        }
        toast.clear();
        that.loading = false;
      }).catch(err => {
        toast.clear();
        that.loading = false;
        this.$toast({
            message: err.message,
            duration: 2000
          });
      });
    },
    initPage(){
      this.getData();
      let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
    }
  },
  created() {
    document.title = "物流信息";
  },
  mounted() {
    this.initPage()
  }
};
</script>
<style>
/* .content .title > a {
  color : #E52B25;
}
.content .titleno > a {
  color : #E52B25;
} */
</style>
<style scoped lang='less'>
.no{
  width: 100%;
  padding-top: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img{
    width: 2.64rem;
    height: 2.09rem;
    margin-bottom: .6rem;
  }
  span{
    font-size: 0.24rem;
    color: #333;
  }
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  box-sizing: border-box;
  .top {
    background: #ffffff;
    height: 2.08rem;
    display: flex;
    .left {
      width: 2.34rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      width: 5.16rem;
      padding: 0.34rem 0;
      span {
        font-family: 500;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.4rem;
        margin-bottom: 0.1rem;
      }
      span:last-of-type {
        margin-bottom: 0;
      }
      .expressCopy{
        display: inline-block;
        margin-left: .24rem;
        font-size: .24rem;
        color: #E52B25;
      }
    }
  }
  .bottom {
    flex-direction: column;
    min-height: calc(100vh - 2.08rem);
    background: #ffffff;
    margin-top: 0.2rem;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    display: flex;
    .tite {
      height: 0.8rem;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-top: 0.1rem;
      span {
        font-size: 0.28rem;
        font-weight: 500;
        color: #333333;
        margin-left: 0.3rem;
      }
    }
    .content {
      margin-bottom: 0.2rem;
      .title {
        font-weight: 500;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.4rem;
      }
      .titleno {
        font-weight: 500;
        line-height: 0.4rem;
        font-size: 0.28rem;
        color: #999999;
      }
      .text {
        color: #999999;
        font-size: 0.24rem;
      }
      .textno {
        color: #999999;
        font-size: 0.24rem;
      }
      .time {
        font-size: 0.24rem;
        color: #999999;
        margin-top: .14rem;
      }
    }
  }
}
</style>
<style lang="stylus" scoped>
.content >>> .van-steps__items >>> .van-step:last-child >>> .van-step__line {
  height:25%;
}
.content >>> .van-steps--vertical {
  padding: 0 0 0 0.98rem;
}

.content >>> .van-icon-checked {
  left: -18px;
}

.content >>> .van-step--vertical.van-step--process .van-icon-checked {
  top: 16px;
}

.content >>> .van-step__circle {
  width: 0.14rem;
  height: 0.14rem;
  background: #CCCCCC;
  left: -18px;
}

.content >>> .van-icon-checked:before {
  content: '';
  display: block;
  width: 0.14rem;
  height: 0.14rem;
  border-radius: 50%;
  background: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/information/logistics.vue